import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './animation.scss';
import React from 'react';
import defaultImage from './no_image.png';
import {Button, Col, Container, Nav, NavItem, Row, TabContent, TabPane, Tooltip} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheckSquare, faSquare} from '@fortawesome/free-regular-svg-icons';
import SourceTreeMap from './SourceTreeMap';
import Lightbox from 'react-image-lightbox';
import {Carousel} from 'react-responsive-carousel';
import NavLink from 'reactstrap/es/NavLink';
import PropTypes from 'prop-types';
import ResourceComponent from '../../../common/ResourceComponent';
import {colorBlockFormatter, dollarsFormatter, impactFormatter} from '../../../common/TableFormatters';
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes';
import {DATE_FORMAT} from '../../../common/StringTools';
import moment from 'moment';
import CustomLightbox from '../../../common/CustomLightbox';
import {faShoppingCart} from '@fortawesome/free-solid-svg-icons';
import EmbItemCarousel from './EmbItemCarousel';
import {getMaterialImageAlt, isFeatureFlagEnabled} from '../../../common/Utils';

class EmbIndustrialPackMassTimberModal extends ResourceComponent {

    state = {
        pictures: [],
        big_pictures: [],
        pictureIndex: null,
        lightbox: false,
        stPictureIndex: null,
        stLightbox: false,
        activeTab: '1',
        animation: false,
        showTooltip: false,
    };

    componentDidMount() {
        const {pictures, big_pictures} = this.props.industrialPack;
        document.querySelector('#root').scrollTo(0, 0);
        if (pictures) {
            this.setState({pictures});
        }
        if (big_pictures) {
            this.setState({big_pictures});
        }
    }

    componentDidUpdate() {
        const is_iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        if (is_iOS && this.state.lightbox) {
            const obj = document.querySelector('.ril__outer');
            const img = document.querySelector('.ril__image');

            if (obj != null) {
                obj.addEventListener('touchmove', function (e) {
                    e.preventDefault();
                }, false);
            }

            if (img != null) {
                img.addEventListener('touchmove', function (e) {
                    e.preventDefault();
                }, false);
            }
        }
    }

    copyToClipboard = () => {
        this.textArea.select();
        document.execCommand('copy');
        this.setState({showTooltip: true}, () => setTimeout(
            () => this.setState({showTooltip: false}), 3000,
        ));
    };

    openGallery = (selectedPicture) => {
        this.setState({lightboxPicture: selectedPicture});
    };

    openStGallery = (picIndex) => {
        this.setState({stPictureIndex: picIndex, stLightbox: true});
    };

    incrementIndex = () => {
        const current = this.state.pictureIndex;
        const last = this.state.big_pictures.length - 1;
        if (current !== last) {
            this.setState({pictureIndex: current + 1});
        }
    };

    decrementIndex = () => {
        const current = this.state.pictureIndex;
        if (current !== 0) {
            this.setState({pictureIndex: current - 1});
        }
    };

    incrementStIndex = () => {
        const sourceTree = this.props.industrialPack.source_tree;
        const current = this.state.stPictureIndex;
        const last = sourceTree.big_pictures.length - 1;
        if (current !== last) {
            this.setState({stPictureIndex: current + 1});
        }
    };

    decrementStIndex = () => {
        const current = this.state.stPictureIndex;
        if (current !== 0) {
            this.setState({stPictureIndex: current - 1});
        }
    };

    createAddress = () => {
        const source_tree = this.props.industrialPack.source_tree;
        const zip = source_tree.zip ? source_tree.zip : '';
        const street = source_tree.street ? source_tree.street : '';
        const city = source_tree.city ? source_tree.city : '';
        const state = source_tree.state ? `, ${source_tree.state}` : '';

        return `${zip} ${street} ${city} ${state}`;
    };

    setImgSrc = (bundle_card_detail, pic) => {
        const {content_type, big_url, original_url, url} = pic;
        let src = '';
        if (content_type.includes('video') || bundle_card_detail.image_size !== 1) {
            src = big_url;
        } else if (content_type.includes('application/pdf')) {
            src = url;
        } else {
            src = original_url;
        }
        return src;
    };

    render() {
        const {
            industrialPack, claimed, closeFn, settings, onClaim, onUnclaim, claimedItems = [], openSubmitModal,
            emptyClaimedItems, ecommerceConnected, claimEnabled,
        } = this.props;
        const {bundle_card_detail} = this.props.settings;
        const source_tree = industrialPack.source_tree;
        const {big_pictures, lightboxPicture, animation, stPictureIndex, stLightbox, showTooltip} = this.state;
        const isCarbonSmartWoodEnabled = isFeatureFlagEnabled(this.props.profile, 'Carbon Smart Wood');

        return (
            <React.Fragment>
                <Container className='embeddable'>
                    {lightboxPicture &&
                        <CustomLightbox
                            selectedDocument={{
                                ...lightboxPicture,
                                alt: getMaterialImageAlt(industrialPack, lightboxPicture),
                            }}
                            documents={industrialPack.pictures}
                            onClose={() => this.setState({lightboxPicture: null})}
                            onMoveSlide={this.handleMoveSlide}
                        />
                    }
                    {claimedItems.length > 0 && (claimEnabled || ((!claimEnabled && ecommerceConnected))) &&
                        <div className='cart pt-2'>
                        <span className='h6 mr-3'>
                            {claimEnabled
                                ? 'Claimed Items'
                                : <span><FontAwesomeIcon icon={faShoppingCart} /> Items In Cart</span>}:
                            <span className='h5 ml-1'><b>{claimedItems.length}</b></span>
                        </span>
                            <Button className='ml-1 mr-1' size='sm' color='success' onClick={openSubmitModal}>
                                {claimEnabled ? 'Submit' : 'Checkout'}
                            </Button>
                            <Button className='ml-1 mr-1' size='sm' color='danger' onClick={emptyClaimedItems}>
                                Cancel
                            </Button>
                        </div>}
                    <Row className='mt-3'>
                        <Col>
                            {bundle_card_detail.tree_name && industrialPack.tree && <span className='h3'>
                                {settings.show_color_block
                                    ? colorBlockFormatter(industrialPack.tree.name + ' packs', industrialPack.tree.color)
                                    : industrialPack.tree.name}
                            </span>}
                            {bundle_card_detail.number &&
                                <span className='h4'> {industrialPack.inventory_number}</span>}
                        </Col>
                        <Col>
                            {bundle_card_detail.speciality && <span className='h4 font-weight-bold'>
                                {industrialPack.specialty ? 'Specialty' : ''}
                            </span>}
                        </Col>
                        {bundle_card_detail.price && <Col>
                            {bundle_card_detail.discount_label && industrialPack.discount && industrialPack.price !== industrialPack.base_price
                                ? <div className='discount-price-card'>
                                    <h3 style={{paddingRight: '20px'}}
                                        className='discounted-price'>{industrialPack.price ? dollarsFormatter(industrialPack.price) : ''}</h3>
                                    <h4 className='base_price'>{industrialPack.price ? dollarsFormatter(industrialPack.price_no_discount) : ''}</h4>
                                </div>
                                :
                                <h3 className='m-0'>{industrialPack.price ? dollarsFormatter(industrialPack.price) : ''}</h3>
                            }
                        </Col>}
                        <Col>
                            <FontAwesomeIcon className='float-right pointer' size='2x' icon={faTimes}
                                             onClick={closeFn} />
                        </Col>
                    </Row>
                    {source_tree &&
                        <Nav tabs>
                            <NavItem>
                                <NavLink active={this.state.activeTab === '1'} onClick={() => this.toggleTab('1')}>
                                    Info
                                </NavLink>
                            </NavItem>
                            {bundle_card_detail.story &&
                                <NavItem>
                                    <NavLink active={this.state.activeTab === '2'} onClick={() => this.toggleTab('2')}>
                                        Story
                                    </NavLink>
                                </NavItem>
                            }
                        </Nav>
                    }
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId='1'>
                            <Row>
                                <Col sm={7}>
                                    {bundle_card_detail.images && <EmbItemCarousel
                                        settings={settings}
                                        big_pictures={big_pictures}
                                        setImgSrc={this.setImgSrc}
                                        openGallery={this.openGallery}
                                        item={industrialPack}
                                        card_detail={bundle_card_detail} />
                                    }
                                </Col>
                                <Col sm={5}>
                                    <div className='description-wrapper margin-top-20'>
                                        {bundle_card_detail.source_type &&
                                            <Row>
                                            <span>
                                                Source Type:
                                                <b className='ml-2 font-weight-bold'>{industrialPack.source_type}</b>
                                            </span>
                                            </Row>
                                        }
                                        {isCarbonSmartWoodEnabled && bundle_card_detail.carbon_smart_wood &&
                                            <Row>
                                            <span>
                                                Carbon Smart Wood&trade;:
                                                <b className='ml-2 font-weight-bold'>{industrialPack.carbon_smart_wood ? 'Yes' : 'No'}</b>
                                            </span>
                                            </Row>
                                        }
                                        {settings.show_carbon_impact &&
                                            <Row>
                                            <span>
                                                Carbon Impact:
                                                <b className='ml-2 font-weight-bold'>{impactFormatter(industrialPack.carbon_impact_mt)}</b>
                                            </span>
                                            </Row>
                                        }
                                        <Row>
                                            <span className='h5 mt-3'>DIMENSIONS</span>
                                        </Row>
                                        {bundle_card_detail.thickness &&
                                            <Row>
                                                <span>Thickness: <b>{industrialPack.thickness || 0}{'"'}</b></span>
                                            </Row>
                                        }
                                        {bundle_card_detail.nominal_board_width &&
                                            <Row>
                                                <span>Nominal Board Width: <b>{industrialPack.nominal_board_width || 0}{'"'}</b></span>
                                            </Row>
                                        }
                                        {bundle_card_detail.actual_thickness &&
                                            <Row>
                                                <span>Actual Thickness: <b>{industrialPack.actual_thickness || 0}{'"'}</b></span>
                                            </Row>
                                        }
                                        {bundle_card_detail.actual_board_width &&
                                            <Row>
                                                <span>Actual Board Width: <b>{industrialPack.actual_board_width || 0}{'"'}</b></span>
                                            </Row>
                                        }
                                        {bundle_card_detail.board_length &&
                                            <Row>
                                                <span>Board Length: <b>{industrialPack.board_length}{'"'}</b></span>
                                            </Row>
                                        }
                                        {bundle_card_detail.board_feet &&
                                            <Row>
                                                <span>Board feet: <b>{industrialPack.total_bf}</b></span>
                                            </Row>
                                        }
                                        {bundle_card_detail.board_ft_price &&
                                            <Row>
                                                <span>BF price: <b>{dollarsFormatter(industrialPack.bf_price)}</b></span>
                                            </Row>
                                        }
                                        <Row className='mt-3'>
                                            <span className='h5 '>
                                                SERVICES
                                            </span>
                                        </Row>
                                        {bundle_card_detail.surfaced &&
                                            <Row>
                                                {industrialPack.surfaced
                                                    ? <span>
                                                    <FontAwesomeIcon className='text-success' icon={faCheckSquare} />
                                                    Already surfaced
                                                </span>
                                                    : <span>
                                                    <FontAwesomeIcon icon={faSquare} />
                                                    Surfaced (additional {dollarsFormatter(industrialPack.surfacing_cost_with_fee)})
                                                </span>
                                                }
                                            </Row>
                                        }
                                        {bundle_card_detail.sanded &&
                                            <Row>
                                                {industrialPack.sanded === true
                                                    ? <span>
                                                    <FontAwesomeIcon className='text-success' icon={faCheckSquare} />
                                                    Already sanded
                                                </span>
                                                    : <span>
                                                    <FontAwesomeIcon icon={faSquare} />
                                                    Sanded (additional {dollarsFormatter(industrialPack.sanding_cost_with_fee)})
                                                </span>
                                                }
                                            </Row>
                                        }
                                        {(bundle_card_detail.characters && industrialPack.characters.length > 0) &&
                                            <React.Fragment>
                                                <Row className='mt-4'>
                                                    <span className='h5'>CHARACTERISTICS </span>
                                                </Row>
                                                {industrialPack.characters.map(ch =>
                                                    <Row key={Math.random()}>
                                                        <FontAwesomeIcon className='text-success'
                                                                         icon={faCheckSquare} />
                                                        <span className='font-weight-bold'>{ch.name}</span>
                                                    </Row>,
                                                )}
                                            </React.Fragment>
                                        }
                                        {(bundle_card_detail.location && industrialPack.location) &&
                                            <React.Fragment>
                                                <Row className='mt-4'>
                                                    <span className='h5'>LOCATION</span>
                                                </Row>
                                                <Row>
                                                    {industrialPack.location}
                                                </Row>
                                            </React.Fragment>
                                        }
                                        {(bundle_card_detail.grading && industrialPack.gradings) &&
                                            <React.Fragment>
                                                <Row className='mt-4'>
                                                    <span className='h5'>GRADING</span>
                                                </Row>
                                                <Row>
                                                    {industrialPack.gradings.map(g => g.name).join(', ')}
                                                </Row>
                                            </React.Fragment>
                                        }
                                        {(bundle_card_detail.category && industrialPack.category) &&
                                            <React.Fragment>
                                                <Row className='mt-4'>
                                                    <span className='h5'>CATEGORY</span>
                                                </Row>
                                                <Row>
                                                    {industrialPack.category}
                                                </Row>
                                            </React.Fragment>
                                        }
                                        {(bundle_card_detail.status && industrialPack.cycle) &&
                                            <React.Fragment>
                                                <Row className='mt-4'>
                                                    <span className='h5'>STATUS</span>
                                                </Row>
                                                <Row>
                                                    {industrialPack.cycle}
                                                </Row>
                                            </React.Fragment>
                                        }
                                        {(bundle_card_detail.description && industrialPack.description) &&
                                            <React.Fragment>
                                                <Row className='mt-4'>
                                                    <span className='h5'>DESCRIPTION</span>
                                                </Row>
                                                <Row>
                                                    {industrialPack.description}
                                                </Row>
                                            </React.Fragment>
                                        }
                                        {bundle_card_detail.share_button &&
                                            <Row className='mt-4'>
                                                <Button
                                                    id='copy'
                                                    size='sm'
                                                    color='info'
                                                    onClick={() => this.copyToClipboard()}>
                                                    Copy URL
                                                </Button>
                                                <Tooltip
                                                    fade={true}
                                                    placement='right'
                                                    isOpen={showTooltip}
                                                    target={'copy'}>
                                                    Copied to clipboard
                                                </Tooltip>
                                                <div>
                                                <textarea
                                                    className='hide-textarea'
                                                    ref={(textarea) => this.textArea = textarea}
                                                    value={`https://${location.hostname}/industrial_packs?item_id=${industrialPack.id}`}
                                                />
                                                </div>
                                            </Row>
                                        }
                                        {(claimEnabled || (ecommerceConnected && !claimEnabled)) && industrialPack.for_sale &&
                                            <Row className='justify-content-center mt-5'>
                                                {claimed
                                                    ? <Button
                                                        size='lg'
                                                        color='info'
                                                        onClick={() => onUnclaim(industrialPack)}>
                                                        {claimEnabled ? 'ON HOLD' : 'IN CART'}
                                                    </Button>
                                                    : <Button
                                                        size='lg'
                                                        className='' color='primary'
                                                        onClick={() => {
                                                            this.setState({animation: true});
                                                            onClaim(industrialPack);
                                                            setTimeout(() => this.setState({animation: false}), 2000);
                                                        }}>
                                                        {claimEnabled ? 'Claim pack' : 'ADD to Cart'}
                                                    </Button>
                                                }
                                            </Row>
                                        }
                                        <Row className='justify-content-center mt-5'>
                                            {animation && <Col>
                                                <Row className='text-center'>
                                                    <Col>
                                                        <div className='success-checkmark'>
                                                            <div className='check-icon'>
                                                                <span className='icon-line line-tip' />
                                                                <span className='icon-line line-long' />
                                                                <div className='icon-circle' />
                                                                <div className='icon-fix' />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className='text-center'>
                                                    <Col>
                                                        <span
                                                            className='text-success mt-4 mb-4'>Item added to cart!</span>
                                                    </Col>
                                                </Row>
                                            </Col>}
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId='2'>
                            <Row>
                                <Col sm={7}>
                                    {bundle_card_detail.story_images &&
                                        <Carousel
                                            infiniteLoop autoPlay={settings.rotate_images} stopOnHover useKeyboardArrows
                                            swipeable emulateTouch
                                            onClickItem={index => {
                                                if (source_tree.big_pictures && source_tree.big_pictures.length > 0) {
                                                    this.openStGallery(index);
                                                }
                                            }}
                                        >
                                            {source_tree && source_tree.pictures && source_tree.pictures.length > 0
                                                ? source_tree.pictures.map((pic, index) =>
                                                    <img
                                                        className='hide-video-icon'
                                                        key={index}
                                                        src={pic.big_url}
                                                        alt={getMaterialImageAlt(industrialPack, pic)}
                                                    />)
                                                : <img
                                                    className={'hide-video-icon'}
                                                    key={Math.random()}
                                                    src={defaultImage}
                                                    alt='Image placeholder for missing image'
                                                />
                                            }
                                        </Carousel>
                                    }
                                </Col>
                                <Col sm={5}>
                                    {source_tree &&
                                        <React.Fragment>
                                            {bundle_card_detail.story_source_type &&
                                                <React.Fragment>
                                                    <Row className='margin-top-10'>
                                                        <span className='h5'>Source Type</span>
                                                    </Row>
                                                    <Row>{source_tree.source_type}</Row>
                                                </React.Fragment>
                                            }
                                            <Row className='margin-top-20'>
                                                {(bundle_card_detail.story_label && source_tree.label) &&
                                                    <Col sm={5}>
                                                        <Row>
                                                            <span className='h5'>Label</span>
                                                        </Row>
                                                        <Row>{source_tree.label}</Row>
                                                    </Col>
                                                }
                                                {(bundle_card_detail.story_removal_date && source_tree.removal_date) &&
                                                    <Col sm={5}>
                                                        <Row>
                                                            <span className='h5'>Removed on:</span>
                                                        </Row>
                                                        <Row>{moment(source_tree.removal_date).format(DATE_FORMAT)}</Row>
                                                    </Col>
                                                }
                                            </Row>
                                            {(bundle_card_detail.story_address && (source_tree.city || source_tree.state)) &&
                                                <React.Fragment>
                                                    <Row className='margin-top-10'>
                                                        <span className='h5'>Address</span>
                                                    </Row>
                                                    <Row>{this.createAddress()}</Row>
                                                </React.Fragment>
                                            }
                                            {(bundle_card_detail.story_description && source_tree.description) &&
                                                <React.Fragment>
                                                    <Row className='margin-top-10'>
                                                        <span className='h5'>Description:</span>
                                                    </Row>
                                                    <Row className=' pre-line'>{source_tree.description}</Row>
                                                </React.Fragment>
                                            }
                                            {(bundle_card_detail.story_map && source_tree.lat) &&
                                                <div className='margin-top-20'>
                                                    <Row className='mt-1'>
                                                        <SourceTreeMap tree={source_tree} style={settings.map_style} />
                                                    </Row>
                                                </div>
                                            }
                                        </React.Fragment>
                                    }
                                </Col>
                            </Row>
                        </TabPane>
                    </TabContent>

                    {stLightbox &&
                        <div className='pan-wrapper'>
                            <Lightbox
                                mainSrc={source_tree.big_pictures[stPictureIndex].big_url}
                                prevSrc={(stPictureIndex === 0) ? undefined : source_tree.big_pictures[stPictureIndex - 1].big_url}
                                nextSrc={(stPictureIndex === source_tree.big_pictures.length - 1) ? undefined : source_tree.big_pictures[stPictureIndex + 1].big_url}
                                onMovePrevRequest={this.decrementStIndex}
                                onMoveNextRequest={this.incrementStIndex}
                                onCloseRequest={() => this.setState({stLightbox: false, stPictureIndex: null})}
                                wrapperClassName='div high-zindex'
                            />
                        </div>
                    }
                </Container>
            </React.Fragment>
        );
    }
}

EmbIndustrialPackMassTimberModal.propTypes = {
    settings: PropTypes.object,
    industrialPack: PropTypes.object,
    closeFn: PropTypes.func,
    onClaim: PropTypes.func,
};

export default EmbIndustrialPackMassTimberModal;



// WEBPACK FOOTER //
// ./src/containers/embeddable/utils/EmbIndustrialPackMassTimberModal.js